import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Loader from "react-loader-spinner";
import { toastMessage } from '../../utils/toast';
import * as userAuthActions from '../../Redux/Actions/user';
import { clearSession } from '../../utils/initiate';
import { useTranslation } from "react-i18next";

const ChangePassword = ({ history }) => {

    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false);
    const userData = useSelector(({User}) => User.data);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const handleChangePassword = () => {
        setButtonLoading(true);
        if ((oldPassword === '') || (newPassword === '') || (confirmPassword === '')){
            setButtonLoading(false);
            toastMessage('error', `Enter the correct details`);
        }
        else if(newPassword !== confirmPassword) {
            setButtonLoading(false);
            toastMessage('error', `Enter the same password in confirm password`);
        }
        else {
            let payload = {
                userId: userData.UserId, oldPassword, newPassword, confirmPassword
            };
            userAuthActions.userChangePassword(payload).then(res => {
                if(res && res.data){
                    toastMessage('success', `Password changed successfully`);
                    setOldPassword(''); setNewPassword(''); setConfirmPassword('');
                    clearSession(dispatch, history);
                }else{
                    toastMessage('error', `Password changed failed`);
                }
                setButtonLoading(false);
            }).catch(err => {
                setButtonLoading(false);
                toastMessage('error', err.response.data.message);
                (err.response.status === 401) && clearSession(dispatch, history);
            });
        }
    }

    return (
        <div className="row">
                <div className="col-lg-12 col-xxl-12">
                    <div className="card border-0 card-stretch">
                        <div className="card-header border-0 py-3">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label font-weight-bolder text-dark">{t("changePassword.title")}</span>
                            </h3>
                        </div>
                        <div className="card-body pt-0 pb-3">
                            <div className="row mb-3">
                                <label className="col-sm-2 ps-0 form-label align-self-center mb-lg-0 text-end">{t("changePassword.oldPassword")}</label>
                                <div className="col-sm-6">
                                    <input placeholder={t("changePassword.oldPasswordPlaceholder")} type="text" className="form-control"
                                        name="Old Password" value={oldPassword} onChange={e => setOldPassword(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-2 ps-0 form-label align-self-center mb-lg-0 text-end">{t("changePassword.newPassword")}</label>
                                <div className="col-sm-6">
                                    <input placeholder={t("changePassword.newPasswordPlaceholder")} type="text" className="form-control"
                                        name="New Password" value={newPassword} onChange={e => setNewPassword(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-2 ps-0 form-label align-self-center mb-lg-0 text-end">{t("changePassword.confirmPassword")}</label>
                                <div className="col-sm-6">
                                    <input placeholder={t("changePassword.confirmPasswordPlaceholder")} type="text" className="form-control"
                                        name="confirmPassword" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
                                    />
                                </div>
                            </div>
                            <button disabled={false} onClick={handleChangePassword} type="button" className="d-flex align-items-center btn btn-primary font-weight-bold my-4">
                            {t("changePassword.btnChange")} {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default ChangePassword;